import Landing from '~/components/ui/Landing';
import { useParams, useNavigate } from 'react-router-dom';
import { aiproUser, subscriptionType, usePopup, useConversation } from '~/helpers/store';
import { useEffect, useState } from 'react';
import Header from '~/components/Header';
import Nav from '~/components/Nav';
import PricingModal from '~/components/Modal/PricingModal';
import axios from "axios";
import ProcessLoading from '~/components/Loading/ProcessLoading';
import { conversationById } from '~/data-provider/api-endpoint';
import { Aemo } from '~/helpers/aemo';
import { status } from "~/helpers/status";
import { SetCookie } from '~/utils/cookie';
const stat = new status();
const app_id = "chatpdf";

export default function Chat() {
  const { conversationId } = useParams();
  const [ isLoading, setIsLoading ] = useState(true);
  const [navVisible, setNavVisible] = useState(() => {
    const savedNavVisible = localStorage.getItem('navVisible');
    return savedNavVisible !== null ? JSON.parse(savedNavVisible) : window.innerWidth > 991;
  });
  const [ pricing, setPricing ] = useState([]);
  const subState = subscriptionType((state) => state);
  const pState = usePopup((state) => state);
  const convoState = useConversation((state) => state);
  const startURL = process.env.REACT_APP_START_URL || 'https://start.ai-pro.org';
  const apiURL = startURL + '/api';
  const navigate = useNavigate();

  useEffect(()=>{
    if(window.innerWidth <= 991) {
      setNavVisible(false);
    }
  }, [conversationId]);

  useEffect(()=>{
      Aemo.init();
      Aemo.validateUser(app_id, (data) => {
          if(data.subscription_type) {
            if(data.subscription_type.toLowerCase() === 'basic') {
              Aemo.showUpgradeModal(true);
              return;
            }
            subState.setType(data.subscription_type);
          } else if(data.has_plan && !data.success) {
            Aemo.showUpgradeModal(true);
            return;
          }
          setIsLoading(false);
      });
      SetCookie('app', 'pro', { domain: '.ai-pro.org' });
      
      axios.post(`${apiURL}/get-pricing`,
        { ppg : 14 },
        { headers: {
          'content-type': 'application/x-www-form-urlencoded'
        } }).then((resp) =>{
            const { data } = resp.data;
            let price = data.filter((price) => { return price.plan_type.toLowerCase() !== 'basic'; } );
            setPricing(price);
      });
  }, []);

  useEffect(()=>{
    convoState.setData({});
    convoState.setMessage([]);
    if(stat.conversationId) {
      stat.clear(); // stop interval
    }
    if (conversationId !== 'new') {
      stat.start(conversationId);
      pState.setShowProcessLoading(true);
      axios.get(`${conversationById(conversationId)}`).then((resp)=>{
        const { data } = resp;
        convoState.setData(data);
        pState.setShowProcessLoading(false);

        if(data.status !== 'completed') {
          const checkStatus = () => {
            axios.post(`/api/convos/status`, {
              conversationId,
              collection_name: data?.collection_name
            }).then((resp) => {
              if(resp.data?.success && resp.data?.status === 'completed') {
                stat.clear(); // stop interval
                let update_convo = convoState.data;
                update_convo.status = "completed";
                update_convo.questionList = resp.data?.questionList;
                update_convo.introduction = resp.data?.introduction;
                convoState.setData(update_convo);
              } else {
                if(resp.data?.status === 'failed') return;
                if(stat.conversationId === resp.data?.id) {
                  setTimeout(()=>{
                    checkStatus();
                  }, 2000);
                }
              }
            });
          }; // check conversation status
          checkStatus();
        }
      }).catch((e)=>{
        navigate(`/chat/new`);
      });
    } else {
      pState.setShowProcessLoading(false);
    }
  }, [conversationId]);

  return (
    <>
      { pState.showPricingPopup ? <PricingModal></PricingModal> : <></> }
      { isLoading ? <LoadingFallback /> :
          <div style={{
              "height": "100%",
              "width": "100%",
              "position": "fixed"
          }}>
              { pState.showProcessLoading ? <ProcessLoading navVisible={navVisible} conversationId={conversationId}></ProcessLoading> : <></> }
              <Header
              />
              <Nav
              navVisible={navVisible}
              setNavVisible={setNavVisible}
              />
              <div className="flex h-full w-full min-w-0 flex-1 flex-col bg-white">
                <Landing conversationId={conversationId} navVisible={navVisible} setNavVisible={setNavVisible}/>
              </div>
          </div>
      }
    </>
  );
}

const bounceKeyframes = `
  @keyframes bounce {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-20px);
    }
  }
`;

const LoadingFallback = () => (
    <>
      <style>{bounceKeyframes}</style>
      <div
        style={{
          display: 'flex',
          height: '100%',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#fff',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '1.5rem',
            fontSize: '1.25rem',
            color: '#083d96',
          }}
        >
          <img
            src="/assets/chatpdfv2-logo.png"
            alt="ChatPDF logo"
            style={{
              height: 'auto',
              width: '100px',
              animation: 'bounce 1s infinite',
            }}
            width="841"
            height="512"
          />
          <p>Loading...</p>
        </div>
      </div>
    </>
);